<template>
  <div id="app" :style="{width:width}">
    <el-form ref="searchform" :model="searchform" label-width="80px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="产品" prop="product_code">
            <el-select
              v-model.trim="searchform.product_code"
              placeholder="请输入产品名称"
              style="width:100%"
              :remote-method="getproductlist"
              filterable
              remote
              :loading="productloading"
            >
              <el-option
                v-for="item in productlistdata"
                :key="item.product_code"
                :label="item.product_name"
                :value="item.product_code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="扫码日期" prop="datelist">
            <el-date-picker
              style="width:100%"
              v-model="searchform.datelist"
              type="daterange"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button @click="resetForm('searchform')">重置</el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getinsepctmap(),chinamap(chartData),mapname = 'china'"
          ></el-button>
          <el-button
            @click="getinsepctmap(),chinamap(chartData),mapname = 'china'"
            icon="el-icon-refresh-right"
            type="success"
          >返回地图</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div id="chinaMap" ref="myEchart" :class="className" :style="{height:height,width:width}"></div>
    <!-- <div id="myChart"></div> -->
  </div>
</template>
<script>
import { insepctmap, insepctmapcity } from "@/api/report";
import { productTree, productlist } from "@/api/base";
var echarts = require("echarts/lib/echarts");
require("echarts/map/js/china"); // 引入中国地图数据
require("echarts/map/js/world"); // 引入世界地图数据
export default {
  name: "App",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "550px"
    },
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.chinamap(val);
      }
    }
  },
  data() {
    return {
      chartData: {
        mapdata: []
      },
      mapname: "china",
      productlistdata: [], //产品列表下拉
      productloading: false,
      // 扫码查询参数
      searchform: {
        product_code: null,
        productCode: null,
        datelist: null
      },
      barndlist: []
    };
  },
  mounted() {
    this.chinamap();
    // 图表初始数据调用
    this.getinsepctmap();
    productlist({ productName: "" }).then(response => {
      this.productlistdata = response.data.data;
    });
  },
  methods: {
    // 窜货查询次数 ，全国各省
    getinsepctmap() {
      insepctmap({
        product_code: this.searchform.product_code,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.chartData.mapdata = [];
        for (let i = 0; i < response.data.length; i++) {
          const obj = {
            name: response.data[i].provinceCodeScan,
            value: response.data[i].qty
          };
          if (obj.name) {
            obj.name = obj.name.substring(0, 2);
          }
          switch (obj.name) {
            case "内蒙":
              obj.name = "内蒙古";
              break;
            case "黑龙":
              obj.name = "黑龙江";
              break;
            case "南海":
              obj.name = "南海诸岛";
              break;
            default:
              break;
          }
          this.chartData.mapdata.push(obj);
        }
      });
    },
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlistdata = response.data.data;
          });
        }, 200);
      } else {
        this.productlistdata = [];
      }
    },
    // 窜货查询次数 ，省查市
    getinsepctmapcity(code) {
      insepctmapcity({
        product_code: this.searchform.product_code,
        provinceCodeScan: code,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.chartData.mapdata = [];
        for (let i = 0; i < response.data.length; i++) {
          const obj = {
            name: response.data[i].cityCodeScan,
            value: response.data[i].qty
          };
          this.chartData.mapdata.push(obj);
        }
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    chinamap({ mapdata } = {}) {
      var myChart = echarts.init(document.getElementById("chinaMap"));
      // window.addEventListener("resize", function() {
      //   myChart.resize();
      // });
      var option = {
        backgroundColor: "#ffffff00", //设置背景颜色
        title: {
          show: true,
          text: "产品异地扫码分布图",
          // subtext: "made by xzc",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        //左侧小导航图标
        visualMap: {
          min: 0,
          max: 1000,
          left: 26,
          bottom: 40,
          showLabel: !0,
          text: ["高", "低"],
          pieces: [
            {
              gt: 100,
              label: "> 100 次",
              color: "#7f1100"
            },
            {
              gte: 50,
              lte: 100,
              label: "50 - 100 次",
              color: "#ff5428"
            },
            {
              gte: 10,
              lt: 50,
              label: "10 - 50 次",
              color: "#ff8c71"
            },
            {
              gt: 1,
              lt: 10,
              label: "1 - 10 次",
              color: "#ffd768"
            },
            {
              value: 0,
              color: "#ffffff"
            }
          ],
          show: !0
        },
        //配置属性
        series: [
          {
            name: "扫码次数",
            type: "map",

            map: this.mapname,
            roam: false,
            zoom: 1.2,
            label: {
              normal: {
                show: true
              },
              emphasis: {
                show: false
              }
            },
            data: mapdata
          }
        ]
      };

      /**
       *  使用刚指定的配置项和数据显示图表。
       *  */
      myChart.setOption(option);
      //获取随机数
      function randomData() {
        return Math.round(Math.random() * (12 - 1) + 1);
      }
      // 窜货查询次数 ，省查市
      var prname = "";
      var chartname = "china";
      myChart.on("mouseover", function(params) {
        let dataIndex = params.dataIndex;
        prname = params.name;
      });
      let getcity = name => {
        this.mapname = name;
        this.getinsepctmapcity(name);
      };
      myChart.on("click", function(chinaParam) {
        if (
          chinaParam.name == "内蒙古" ||
          chinaParam.name == "黑龙江" ||
          chinaParam.name.length == 2 ||
          chinaParam.name == "北京"
        ) {
          var option = myChart.getOption();
          option.series[0].map = chinaParam.name;
          option.series[0].mapType = chinaParam.name;
          myChart.dispose();
          var myChar = echarts.init(document.getElementById("chinaMap"));
          myChar.setOption(option, true);
          getcity(chinaParam.name);
          return;
        }
      });
    }
  },
  created() {}
};
</script>